/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「邮政编码弹框的组件」
 */
<template>
  <div>
    <f7-actions
      class="cPostalPopup-container"
      :closeByBackdropClick="true"
      ref="SearchActionSheetAddress"
      :opened="show"
      @actions:open="actionOpenHandle"
      @actions:closed="actionCloseHandle"
    >
      <div class="top-line"></div>
      <div class="cPostalPopup-title">
        <p>{{ title }}</p>
        <div class="img-box" @click="actionCloseHandle">
          <img src="../../assets/img/delete.png" alt="" />
        </div>
      </div>
      <p class="cPostalPopup-tips" v-if="isManual == false">{{ tips }}</p>
      <p class="cPostalPopup-tips" v-if="isManual">{{ placeholder }}</p>
      <ul
        class="cPostalPopup-list"
        v-if="selectdata.length > 0 && status == 'end' && isManual == false"
      >
        <li
          v-for="(item, index) in selectdata"
          :key="index"
          @click="handleSelect(item)"
        >
          {{ item.text }}
        </li>
<!--        <li @click="openInput">上記以外(手入力)</li>-->
        <li @click="actionCloseHandle">上記以外(手入力)</li>
      </ul>
      <div
        v-if="selectdata.length == 0 && status == 'end' && isManual == false"
        class="bnt-by"
      >
        <cNoBgButton
          text="閉じる"
          :disabled="false"
          @clickbtn="actionCloseHandle"
        ></cNoBgButton>
        <span></span>
        <cRoundButton
          v-if="false"
          text="住所を手入力する"
          @clickbtn="openInput"
        ></cRoundButton>
      </div>
      <div class="input-by" v-if="isManual">
        <cAddressInput
          class="input-address"
          :placeholder="placeholder"
          v-model.trim="addressText"
          :message="msg"
          :formatError="formatError"
          @blur="handleBlur"
          @input="
            (value) => {
              handleInput(value);
            }
          "
        ></cAddressInput>
        <cRoundButton
          text="OK"
          :disabled="isOver"
          @clickbtn="saveInput"
        ></cRoundButton>
      </div>
    </f7-actions>
  </div>
</template>

<script>
import cAddressInput from '../Input/cAddressInput';
export default {
  props: ['show', 'selectdata', 'title', 'tips', 'status'],
  data() {
    return {
      isManual: false,
      addressText: '',
      placeholder: '住所を入力してください',
      msg: '正しい住所を入力してください',
      formatError: false
    };
  },
  components: { cAddressInput },
  computed: {
    isOver() {
      if (this.addressText && !this.formatError) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    actionOpenHandle() {},
    actionCloseHandle() {
      this.$emit('clickclose');
      this.isManual = false;
      this.formatError = false;
      this.addressText = '';
      this.placeholder = '住所を入力してください';
      this.msg = '正しい住所を入力してください';
    },
    handleSelect(item) {
      this.$emit('clickselect', item);
      this.actionCloseHandle();
    },
    openInput() {
      this.isManual = true;
    },
    saveInput() {
      let result = this.parseAddress(this.addressText);
      if (result && result[1]) {
        let newArr = result.filter((item) => {
          return !!item;
        });
        let areaCode = this.commonData.areaData
          .filter((item) => {
            return item.value == newArr[1];
          })
          .map((e) => e.id)[0];
        let obj = {
          address1: newArr[1] || '',
          address2: newArr[2] || newArr[1] || '',
          address3: '',
          area_cd: areaCode,
          text: result.input
        };
        this.handleSelect(obj);
      }
    },
    handleBlur() {
      const ranges = [
        '[\u2700-\u27BF]',
        '[\uE000-\uF8FF]',
        '\uD83C[\uDC00-\uDFFF]',
        '\uD83D[\uDC00-\uDFFF]',
        '[\u2011-\u26FF]',
        '\uD83E[\uDD10-\uDDFF]'
      ];
      let reg = new RegExp(ranges.join('|'), 'g');
      this.addressText = this.addressText.replace(reg, '');
      this.addressText = this.addressText.trim().replace(/\u0020/g, '\u3000');
      this.addressText = this.addressText.replace(
        /[A-Za-z0-9\uff0d\u2796\u30fc\u002d\uff70\u2014\u2013\u2212]/g,
        function (s) {
          if (s.match(/[\uff0d\u2796\u30fc\u002d\uff70\u2014\u2013\u2212]/)) {
            return '\u30fc';
          }
          return String.fromCharCode(s.charCodeAt(0) + 0xfee0);
        }
      );

      this.parseAddress(this.addressText);
    },
    handleInput(value) {
      this.parseAddress(this.addressText);
    },
    parseAddress(matchString) {
      let result = matchString.match(
        /(北海道|青森県|岩手県|宮城県|秋田県|山形県|福島県|茨城県|栃木県|群馬県|埼玉県|千葉県|東京都|神奈川県|新潟県|富山県|石川県|福井県|山梨県|長野県|岐阜県|静岡県|愛知県|三重県|滋賀県|京都府|大阪府|兵庫県|奈良県|和歌山県|鳥取県|島根県|岡山県|広島県|山口県|徳島県|香川県|愛媛県|高知県|福岡県|佐賀県|長崎県|熊本県|大分県|宮崎県|鹿児島県|沖縄県)?(.*)/
      );
      if (result && result[1] && this.commonJs.isAllFullwidthStr(matchString)) {
        this.formatError = false;
      } else {
        this.formatError = true;
        return null;
      }

      return result;
    }
  }
};
</script>
<style lang="less" >
.cPostalPopup-container {
  border-top-left-radius: 0.12rem;
  border-top-right-radius: 0.12rem;
  background-color: #fff;
  .top-line {
    width: 0.4rem;
    height: 0.04rem;
    background: #e0e0e0;
    border-radius: 0.02rem;
    margin: 0.1rem auto;
  }
  .cPostalPopup-title {
    font-size: 0.2rem;
    padding: 0 0.2rem;
    display: flex;
    align-items: center;
    position: relative;
    margin: 0.2rem 0;
    p {
      flex: 1;
      text-align: center;
    }
    .img-box {
      position: absolute;
      right: 0.2rem;
      width: 0.6rem;
      height: 0.4rem;
      text-align: center;
      line-height: 0.4rem;
      cursor: pointer;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
  .cPostalPopup-tips {
    text-align: left;
    font-size: 0.16rem;
    padding: 0 0.2rem;
  }
  .cPostalPopup-list {
    margin: 0.2rem 0;
    padding: 0 0.2rem 0.1rem 0.2rem;
    li {
      width: 100%;
      height: 0.4rem;
      font-size: 0.14rem;
      line-height: 0.4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
      border: 0.01rem solid rgba(143, 143, 143, 0.5);
      border-radius: 0.02rem;
      margin: 0.1rem 0;
      cursor: pointer;
    }
  }
  .bnt-by {
    display: flex;
    padding: 0.2rem 0.2rem;
    span {
      display: inline-flex;
      width: 0.2rem;
    }
  }
  .input-by {
    padding: 0.2rem 0.2rem;
    .input-address {
      margin-bottom: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/cPostalPopup.vue